import Vue from 'vue'

import 'lodash'
import Buefy from 'buefy'
import VueTheMask from 'vue-the-mask'
import VueSelectImage from 'vue-select-image'

require('vue-select-image/dist/vue-select-image.css')

Vue.use(Buefy)
Vue.use(VueTheMask)
Vue.use(VueSelectImage)
